export const optionsForLegal = [
    {name: 'identificationNumber', label: 'საიდენტიფიკაციო ნომერი'},
    {name: 'licenseHolderOrganization', label: 'ნებართვის მაძიებელი/მფლობელი ორგანიზაცია'},
    {name: 'organizationLegalAddress', label: 'ორგანიზაციის იურიდიული მისამართი'},
    {name: 'ownerIdentificationCode', label: 'ობიექტის მფლობელის საიდენტიფიკაციო კოდი'},
    {name: 'ownerName', label: 'ობიექტის მფლობელის დასახელება'},
    {name: 'ownerLegalAddress', label: 'ობიექტის მფლობელის იურიდიული მისამართი'}
];

export const optionsForPhysical = [
    {name: 'personalNumber', label: 'დამკვეთის პირადი ნომერი'},
    {name: 'lastName', label: 'დამკვეთის გვარი'},
    {name: 'firstName', label: 'დამკვეთის სახელი'}
];

export const optionsForAssociation = [
    {name: 'associationId', label: 'დამკვეთის საიდენთიფიკაციო ნომერი'},
    {name: 'associationName', label: 'დამკვეთის სახელი'},
    {name: 'associationAddress', label: 'დამკვეთის იურიდიული მისამართი'}
];

export const optionsForForeigner = [
    {name: 'passportNumber', label: 'პასპორტის ნომერი'},
    {name: 'foreignerName', label: 'დამკვეთის სახელი'},
    {name: 'foreignerAddress', label: 'მისამართი'},
    {name: 'country', label: 'ქვეყანა'}
];


export const optionsForLegalExp = [
    {name: 'identificationNumber', label: 'ობიექტის ექსპლუატაციის გამწევი პირის საიდენტიფიკაციო კოდი'},
    {name: 'ownerName', label: 'ობიექტის ექსპლუატაციის გამწევი პირის დასახელება'},
    {name: 'ownerLegalAddress', label: 'ობიექტის ექსპლუატაციის გამწევი პირის იურიდიული მისამართი'}
];

export const optionsForPhysicalExp = [
    {name: 'personalNumber', label: 'ობიექტის ექსპლუატაციის გამწევი პირის პირადი ნომერი'},
    {name: 'lastName', label: 'ობიექტის ექსპლუატაციის გამწევი პირის გვარი'},
    {name: 'firstName', label: 'ობიექტის ექსპლუატაციის გამწევი პირის სახელი'}
];

export const optionsForAssociationExp = [
    {name: 'associationId', label: 'ობიექტის ექსპლუატაციის გამწევი პირის საიდენთიფიკაციო ნომერი'},
    {name: 'associationName', label: 'ობიექტის ექსპლუატაციის გამწევი პირის სახელი'},
    {name: 'associationAddress', label: 'ობიექტის ექსპლუატაციის გამწევი პირის იურიდიული მისამართი'}
];

export const optionsForForeignerExp = [
    {name: 'passportNumber', label: 'ობიექტის ექსპლუატაციის გამწევი პირის პასპორტის ნომერი'},
    {name: 'foreignerName', label: 'ობიექტის ექსპლუატაციის გამწევი პირის სახელი'},
    {name: 'foreignerAddress', label: 'ობიექტის ექსპლუატაციის გამწევი პირის მისამართი'},
    {name: 'country', label: 'ქვეყანა'}
];

export const valuesToDelete = [
    "ობიექტის ექსპლუატაციის გამწევი პირის საიდენტიფიკაციო კოდი",
    "დამკვეთის სახელი",
    "დამკვეთის იურიდიული მისამართი",
    "პასპორტის ნომერი",
    "მისამართი",
    "ქვეყანა",
    "დამკვეთის პირადი ნომერი",
    "დამკვეთის გვარი",
    "საიდენტიფიკაციო ნომერი",
    "ნებართვის მაძიებელი/მფლობელი ორგანიზაცია",
    "ორგანიზაციის იურიდიული მისამართი",
    "ობიექტის მფლობელის საიდენტიფიკაციო კოდი",
    "ობიექტის მფლობელის დასახელება",
    "ობიექტის მფლობელის იურიდიული მისამართი",
    "ობიექტის მფლობელის საიდენტიფიკაციო კოდი",
]

export const valuesToDeleteExp = [
    "დამკვეთის საიდენთიფიკაციო ნომერი",
    "ობიექტის ექსპლუატაციის გამწევი პირის დასახელება",
    "ობიექტის ექსპლუატაციის გამწევი პირის იურიდიული მისამართი",
    "ობიექტის ექსპლუატაციის გამწევი პირის პირადი ნომერი",
    "ობიექტის ექსპლუატაციის გამწევი პირის გვარი",
    "ობიექტის ექსპლუატაციის გამწევი პირის სახელი",
    "ობიექტის ექსპლუატაციის გამწევი პირის პასპორტის ნომერი",
    "ობიექტის ექსპლუატაციის გამწევი პირის სახელი",
    "ობიექტის ექსპლუატაციის გამწევი პირის მისამართი",
    "ობიექტის ექსპლუატაციის გამწევი პირის საიდენტიფიკაციო კოდი",
    "ქვეყანა",
]

